type PostHogLogAttributes = Record<string, string | number | boolean>;

type PostHogClient = {
  logger?: {
    info: (message: string, attributes: PostHogLogAttributes) => void;
  };
};

export const posthogLogs = {
  signInCompleted(
    posthog: PostHogClient | undefined,
    attributes: PostHogLogAttributes,
  ) {
    posthog?.logger?.info('user_sign_in_completed', attributes);
  },

  goalCreated(
    posthog: PostHogClient | undefined,
    attributes: PostHogLogAttributes,
  ) {
    posthog?.logger?.info('goal_creation_completed', attributes);
  },

  workspaceMembersInvited(
    posthog: PostHogClient | undefined,
    attributes: PostHogLogAttributes,
  ) {
    posthog?.logger?.info('workspace_member_invitation_completed', attributes);
  },
};
